import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuthStatus } from "../hooks/useAuth";
import { firebaseSignOut } from "../lib/firebase";

export default function Layout() {
  const { data: authStatus } = useAuthStatus();
  return (
    <div className="flex min-h-screen flex-col bg-bg text-text">
      <header className="border-b border-border">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6">
          <Link to="/" className="font-serif text-xl font-semibold tracking-tight text-text">
            Boort
          </Link>
          <nav className="flex items-center gap-6 text-sm font-medium">
            <NavLink
              to="/"
              end
              className={({ isActive }) => (isActive ? "text-accent" : "text-muted hover:text-text")}
            >
              Library
            </NavLink>
            <NavLink
              to="/chat"
              className={({ isActive }) => (isActive ? "text-accent" : "text-muted hover:text-text")}
            >
              Chat
            </NavLink>
            <NavLink
              to="/settings"
              className={({ isActive }) => (isActive ? "text-accent" : "text-muted hover:text-text")}
            >
              Settings
            </NavLink>
            {authStatus?.mode === "firebase" ? (
              <button
                type="button"
                onClick={() => void firebaseSignOut()}
                title={authStatus.email ?? undefined}
                className="text-muted hover:text-text"
              >
                Sign out
              </button>
            ) : null}
          </nav>
        </div>
      </header>
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
